import * as types from '../mutation-types'
import router from '../../router'
import * as api from '../api'
import moment from 'moment'
import _ from 'lodash'

const state = {
  current_server_time: '',
  current_server_time_received_timestamp: new Date(0),
  machine_type: {},
  schedule_info: {
    day_schedule_name: 'N/A',
    next_bell_time: 'N/A'
  },
  current_year: new Date().getFullYear(),
  is_authenticated: false,
  logged_in_user: {},
  scoped_site_id: 1,
  site_of_ip: {},
  disabled_change_scoped_site: false,
  version: 'N/A'
}

const getters = {
  currentServerTime: state => state.current_server_time,
  machineType: state => state.machine_type,
  scheduleInfo: state => state.schedule_info,
  nextBellTime: state => state.next_bell_time,
  stopActiveBellsResult: state => state.stop_active_bells_result,
  currentYear: state => state.current_year,
  isAuthenticated: state => state.is_authenticated,
  loggedInUser: state => state.logged_in_user,
  scopedSiteId: state => state.scoped_site_id,
  siteOfIp: state => state.site_of_ip,
  disabledChangeScopedSite: state => state.disabled_change_scoped_site,
  version: state => state.version
}

const actions = {
  getCurrentServerTime ({ commit }) {
    const diff = Math.abs(new Date(state.current_server_time_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('current_time')
        .then(function (response) {
          commit(types.RECEIVE_CURRENT_TIME_RESULT, response.data.current_time)
        })
    } else {
      commit(types.INCREMENT_CURRENT_TIME, 1)
    }
  },
  getMachineType ({ commit }) {
    api.instance.get('phoenix_settings/1/MACHINE/TYPE')
      .then(function (response) {
        const machineType = response.data.phoenix_setting.value
        commit(types.RECEIVE_MACHINE_TYPE, machineType)
      })
  },
  getScheduleInfo ({ commit, rootGetters }) {
    api.instance.get('schedule_info/' + rootGetters.scopedSiteId)
      .then(function (response) {
        commit(types.RECEIVE_SCHEDULE_INFO, response.data.schedule_info)
      })
  },
  getCurrentDaySchedule ({ commit }) {
  },
  getVersion ({ commit }) {
    api.instance.get('version')
      .then(function (response) {
        commit(types.RECEIVE_VERSION, response.data.version)
      })
  },
  stopActiveBells ({ commit, rootGetters }) {
    api.instance.post('uds_message', {
      command: 'stop_all_active_bells',
      site_id: rootGetters.scopedSiteId
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Active bells successfully stopped.')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  stopActiveAnnouncements ({ commit, rootGetters }) {
    api.instance.post('uds_message', {
      command: 'stop_all_active_announcements',
      site_id: rootGetters.scopedSiteId
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Active announcements successfully stopped.')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  stopActiveAlerts ({ commit, rootGetters }) {
    api.instance.post('uds_message', {
      command: 'stop_all_active_alerts',
      site_id: rootGetters.scopedSiteId
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Active alerts successfully stopped.')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  executeTts ({ rootGetters }, ttsData) {
    if (ttsData.message === '') {
      alert('Please enter a message')
      return
    }

    if (ttsData.zones.length < 1) {
      alert('Please choose at least one zone to send the message to')
      return
    }

    api.instance.post('uds_message', {
      command: 'execute_tts',
      site_id: rootGetters.scopedSiteId,
      message: ttsData.message,
      voice: ttsData.voice,
      zone_ids: ttsData.zones.map(zone => zone.value)
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Text-to-Speech successfully started.')
        /* eslint-disable-next-line */
        $('#textToSpeechModal').modal('hide')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  isAuthenticated () {
    // check if a session is stored
    if (sessionStorage.getItem('logged_in_data')) {
      let parsedData = JSON.parse(sessionStorage.getItem('logged_in_data'))
      let expireDate = parsedData.date_expire
      if (Date.now() <= new Date(expireDate)) {
        state.logged_in_user = parsedData.logged_in_user
        state.scoped_site_id = parsedData.scoped_site_id
        state.is_authenticated = parsedData.is_authenticated
      } else {
        router.push({ name: 'Home' })
      }
    }
  },
  login ({ commit }, loginData) {
    if (loginData.username !== '') {
      if (loginData.password !== '') {
        api.instance.post('authenticate', loginData)
          .then(function (response) {
            if (response.data.success === 'true') {
              commit(types.LOGIN, response.data.user[0])
              router.push({ name: 'Home' })
            } else {
              alert(response.data.message)
            }
          })
      } else {
        alert('Password is required')
      }
    } else {
      alert('Username is required')
    }
  },
  logout ({ commit }) {
    commit(types.LOGOUT)
    router.push({ name: 'Home' })
  },
  changeScopedSiteId ({ commit }, siteId) {
    commit(types.CHANGE_SCOPED_SITE_ID, siteId)
    commit(types.CHANGE_SELECTED_DAY_SCHEDULE_ID, 0)
  },
  determineSiteOfIp ({ commit }, sites) {
    if (_.isEmpty(state.site_of_ip)) {
      let site = sites.find(site => location.origin.includes(site.ip) || location.origin.includes(site.alt_name))

      if (!_.isEmpty(site)) {
        commit(types.DETERMINED_SITE_OF_IP, site)
        commit(types.CHANGE_SCOPED_SITE_ID, site.site_id)
      }
    }
  },
  setDisabledChangeScopedSite ({ commit }, value) {
    commit(types.TOGGLE_DISABLED_CHANGE_SCOPED_SITE, value)
  }
}

const mutations = {
  [types.RECEIVE_CURRENT_TIME_RESULT] (state, currentTime) {
    state.current_server_time = moment(currentTime)
    state.current_server_time_received_timestamp = Date.now()
  },
  [types.INCREMENT_CURRENT_TIME] (state, inc) {
    state.current_server_time = moment(state.current_server_time).add(inc, 's')
  },
  [types.RECEIVE_MACHINE_TYPE] (state, machineType) {
    state.machine_type = machineType
  },
  [types.RECEIVE_SCHEDULE_INFO] (state, scheduleInfo) {
    state.schedule_info = scheduleInfo
    if (state.schedule_info.next_bell_time !== 'None') {
      state.schedule_info.next_bell_time = moment(state.schedule_info.next_bell_time)
    }
  },
  [types.LOGIN] (state, loginData) {
    state.is_authenticated = true
    state.logged_in_user = loginData

    if ([1, 2].includes(loginData.group_id)) {
      state.scoped_site_id = loginData.assigned_site_ids[0]
    }

    // save session
    sessionStorage.setItem('logged_in_data', JSON.stringify({
      'is_authenticated': state.is_authenticated,
      'logged_in_user': state.logged_in_user,
      'scoped_site_id': state.scoped_site_id,
      'date_created': moment(Date.now()).toDate(),
      'date_expire': moment(Date.now()).add(30, 'm').toDate()
    }))
  },
  [types.LOGOUT] (state) {
    state.is_authenticated = false
    state.logged_in_user = {}

    sessionStorage.removeItem('logged_in_data')
  },
  [types.CHANGE_SCOPED_SITE_ID] (state, siteId) {
    state.scoped_site_id = siteId

    let parsedData = JSON.parse(sessionStorage.getItem('logged_in_data'))
    parsedData.scoped_site_id = siteId
    sessionStorage.setItem('logged_in_data', JSON.stringify(parsedData))
  },
  [types.TOGGLE_DISABLED_CHANGE_SCOPED_SITE] (state, value) {
    state.disabled_change_scoped_site = value
  },
  [types.DETERMINED_SITE_OF_IP] (state, site) {
    state.site_of_ip = site
  },
  [types.RECEIVE_VERSION] (state, version) {
    state.version = version
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
